<template>
  <div>
    <b-card no-body>
      <!-- Head -->
      <table-header
        search
        search-placeholder="Cari berdasarkan nama"
        search-action="setting/getSettingsList"
      >
        <template #action>
          <b-button
            v-if="canAccess('manage', 'Setting')"
            variant="primary"
            :to="{ name: 'settings-create'}"
          >
            + Buat Pengaturan
          </b-button>
        </template>
      </table-header>
      <!-- Body -->
      <b-skeleton-table
        v-if="isLoading"
        :rows="5"
        :columns="4"
      />
      <b-table
        v-else
        ref="refUserListTable"
        :items="settings.data"
        responsive
        :fields="tableFields"
        primary-key="id"
        show-empty
        empty-text="Tidak ada data yang ditemukan"
        class="position-relative mh-160"
      >

        <!-- Column: Name -->
        <template #cell(name)="data">
          {{ data.item.name }}
        </template>

        <!-- Column: Guard Name -->
        <template #cell(key)="data">
          {{ data.item.key }}
        </template>

        <!-- Column: Guard Name -->
        <template #cell(value)="data">
          <div class="text-value">
            {{ data.item.value }}
          </div>
        </template>

        <!-- Column: Actions -->
        <template
          v-if="canAccess('manage', 'Setting')"
          #cell(actions)="data"
        >
          <div class="text-nowrap">
            <table-action
              :actions="tableAction"
              :data="data"
            />
          </div>
        </template>

      </b-table>
      <!-- Footer -->
      <div class="mx-2 mb-2">
        <pagination
          :data="settings.meta"
          action="setting/getSettingsList"
        />
      </div>
    </b-card>

    <b-modal
      v-if="canAccess('manage', 'Setting')"
      id="modal-delete"
      title="Apakah anda yakin"
      @hidden="deletedData = ''"
    >
      Ingin Menghapus Pengaturan ini?
      <template #modal-footer="{ cancel }">
        <b-button
          variant="outline-secondary"
          :disabled="isDeleting"
          @click="cancel()"
        >
          Batalkan
        </b-button>
        <b-button
          variant="danger"
          :disabled="isDeleting"
          @click.prevent="handleDelete"
        >
          <b-spinner
            v-if="isDeleting"
            small
            label="Spinning"
          />
          {{ isDeleting ? 'Menghapus' : 'Ya, Hapus' }}
        </b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import {
  BSkeletonTable,
  BCard,
  BButton,
  BTable,
  BSpinner,
} from 'bootstrap-vue'
import Pagination from '@/layouts/components/custom/Pagination.vue'
import TableHeader from '@/layouts/components/custom/TableHeader.vue'
import TableAction from '@/layouts/components/custom/TableAction.vue'

export default {
  components: {
    BSkeletonTable,
    BCard,
    BButton,
    BTable,
    BSpinner,
    Pagination,
    TableHeader,
    TableAction,
  },
  data() {
    return {
      tableFields: [
        { key: 'name', label: 'Nama' },
        { key: 'key', label: 'Key' },
        { key: 'value', label: 'Value' },
        { key: 'actions', label: '', thStyle: { width: '1%' } },
      ],
      deletedData: '',
      isDeleting: false,
    }
  },
  computed: {
    ...mapState('setting', ['settings', 'isLoading']),
    query() {
      return this.$route.query
    },
    tableAction() {
      return [
        {
          access: null,
          to: 'settings-edit|key:key',
          action: '',
          icon: 'EditIcon',
          title: 'Edit',
        },
        {
          access: null,
          to: null,
          action: data => { this.deleteConfirmation(data.key) },
          icon: 'TrashIcon',
          title: 'Hapus',
        },
      ]
    },
  },
  async created() {
    await this.getSettingsList(this.query)
  },
  methods: {
    ...mapActions('setting', ['getSettingsList', 'deleteSetting']),
    deleteConfirmation(value) {
      this.$bvModal.show('modal-delete')
      this.deletedData = value
    },
    async handleDelete() {
      this.isDeleting = true
      await this.deleteSetting({ settingKey: this.deletedData })
      this.isDeleting = false
      this.$bvModal.hide('modal-delete')
    },
  },
}
</script>

<style lang="scss" scoped>
.text-value {
  white-space: nowrap;
  width: 200px;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
